__turbopack_context__.v({
  "className": "brown_83c44312-module__tcXoia__className",
  "variable": "brown_83c44312-module__tcXoia__variable",
});
